import Button from '@/components/base/button/button';
import Divider from '@/components/base/divider/divider';
import PhosphorIcon from '@/components/base/icon/phosphor-icon';
import { ArrowRight } from '@phosphor-icons/react';
import { useTranslations } from 'next-intl';

interface Props {
  href: string;
  title?: string;
  divider?: boolean;
}

export const LinkToEntireCategory = ({
  href,
  title,
  divider,
  ...rest
}: Props) => {
  const t = useTranslations('navigation.main_section');

  return (
    <>
      <li>
        <Button
          className="!px-xs h-clickable-minimum"
          variant="tertiary-no-frame"
          isLink
          href={href}
          linkRestProps={rest}
          testId={'link-to-entire-category'}
        >
          <div className="flex h-full w-full items-center justify-between gap-xxs">
            <span className="text-default text-nav-label">
              {title || t('see_all')}
            </span>
            <PhosphorIcon Icon={ArrowRight} className="icon-m text-brand" />
          </div>
        </Button>
      </li>
      {divider && (
        <div className="flex px-xs">
          <Divider className="inset-xs my-xs" />
        </div>
      )}
    </>
  );
};
